window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Background_Blue = function() {
	this.initialize(img.PreloadAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.ProfessorRod = function() {
	this.initialize(img.PreloadAssets_ProfessorRod);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2277,2084);


(lib.Splashscreen = function() {
	this.initialize(img.PreloadAssets_Splashscreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2667,6188);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.TextSamplesSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// tf
	this.textfield1 = new cjs.Text("Font", "120px 'Poppins'", "#FF0000");
	this.textfield1.name = "textfield1";
	this.textfield1.lineHeight = 211;
	this.textfield1.lineWidth = 353;
	this.textfield1.parent = this;
	this.textfield1.setTransform(90.8,47.45);
ranj.TextOffsetFixer.fix(this.textfield1);

	this.timeline.addTween(cjs.Tween.get(this.textfield1).wait(1));

	// tf
	this.textfield2 = new cjs.Text("Font ", "60px 'Poppins'");
	this.textfield2.name = "textfield2";
	this.textfield2.lineHeight = 106;
	this.textfield2.lineWidth = 282;
	this.textfield2.parent = this;
	this.textfield2.setTransform(95.4,73.75);
ranj.TextOffsetFixer.fix(this.textfield2);

	this.timeline.addTween(cjs.Tween.get(this.textfield2).wait(1));

	// tf
	this.textfield2_1 = new cjs.Text("Font ", "30px 'Poppins'", "#FF6600");
	this.textfield2_1.name = "textfield2_1";
	this.textfield2_1.lineHeight = 53;
	this.textfield2_1.lineWidth = 93;
	this.textfield2_1.parent = this;
	this.textfield2_1.setTransform(97.75,86.9);
ranj.TextOffsetFixer.fix(this.textfield2_1);

	this.timeline.addTween(cjs.Tween.get(this.textfield2_1).wait(1));

	// guide 
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0000FF").ss(1,1,1,3,true).p("AAAAAIAAH0AH0AAIn0AAAAAnzIAAHzInzAA");
	this.shape.setTransform(100,100);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TextSamplesSkin, new cjs.Rectangle(49,45.5,1091.3,905.7), null);


(lib.LoadingBarFront = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("AgJAeQgNAAgJgJQgIgIAAgNQAAgLAIgKQAJgIANAAIATAAQAMAAAJAIQAJAKAAALQAAANgJAIQgJAJgMAAg");
	this.shape.setTransform(4,3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarFront, new cjs.Rectangle(0,0,8,6), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-667,-1286,1.3655,1.3655);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667,-1286,1334.1,2802), null);


(lib.LoadingBarBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("ApjAeIAAg7ITHAAIAAA7g");
	this.shape.setTransform(61.2,3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarBar, new cjs.Rectangle(0,0,122.4,6), null);


(lib.LoadingBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_99 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(99).call(this.frame_99).wait(1));

	// Layer_3 copy
	this.instance = new lib.LoadingBarFront();
	this.instance.setTransform(6,5,1,1,0,0,0,4,3);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:287},99).wait(1));

	// LoadingBarBar
	this.instance_1 = new lib.LoadingBarBar();
	this.instance_1.setTransform(6,2,0.0082,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:2.2875},99).wait(1));

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("AgJAeQgNAAgJgJQgIgIAAgNQAAgLAIgKQAJgIANAAIATAAQAMAAAJAIQAJAKAAALQAAANgJAIQgJAJgMAAg");
	this.shape.setTransform(6,5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(100));

	// Layer_2
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("A2GAyQgUAAgPgPQgPgOAAgVQAAgUAPgOQAPgPAUAAMAsNAAAQAUAAAPAPQAPAOAAAUQAAAVgPAOQgPAPgUAAg");
	this.shape_1.setTransform(146.5,5);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(100));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,293,10);


(lib.PreloadScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// loadingBar
	this.loadingBar = new lib.LoadingBar();
	this.loadingBar.name = "loadingBar";
	this.loadingBar.setTransform(-403,688,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.loadingBar).wait(1));

	// Professor
	this.instance = new lib.ProfessorRod();
	this.instance.setTransform(-280,262,0.2846,0.2854);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.instance_1 = new lib.Splashscreen();
	this.instance_1.setTransform(766.5,-1032,0.5,0.5,0,0,180);

	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.instance_1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PreloadScreenSkin, new cjs.Rectangle(-667.5,-1286,1746.9,3348), null);


// stage content:
(lib.PreloadAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TextSamplesSkin
	this.instance = new lib.TextSamplesSkin();
	this.instance.setTransform(-752.35,-370.55);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.instance_1 = new lib.PreloadScreenSkin();
	this.instance_1.setTransform(538.8,872,1,1,0,0,0,-1.2,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-181.1,456,1487.6,2477);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#0F97FF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/PreloadAssets/Background_Blue.png", id:"PreloadAssets_Background_Blue", bundle:"PreloadAssets"},
		{src:"assets/skins/images/PreloadAssets/ProfessorRod.png", id:"PreloadAssets_ProfessorRod", bundle:"PreloadAssets"},
		{src:"assets/skins/images/PreloadAssets/Splashscreen.png", id:"PreloadAssets_Splashscreen", bundle:"PreloadAssets"}
	],
	preloads: []
};



})(lib.PreloadAssets = {}, images, ss, createjs);
module.exports = lib.PreloadAssets;